<div class="flex flex-column gap-3">
  <div class="formgrid  grid border-1 border-solid surface-border border-round p-3"
    *ngFor="let author of otherAuthors; let idx = index">
    <div class="field col-12 md:col-4">
      <label for="lastName{{idx}}">Фамилия</label>
      <input id="lastName{{idx}}" type="text" class="w-full" pInputText [(ngModel)]="author.lastName">
    </div>
    <div class="field md:col-4 col-12">
      <label for="firstName{{idx}}">Имя</label>
      <input id="firstName{{idx}}" type="text" class="w-full" pInputText [(ngModel)]="author.firstName">
    </div>
    <div class="field md:col-4 col-12">
      <label for="middleName{{idx}}">Отчество</label>
      <input id="middleName{{idx}}" type="text" class="w-full" pInputText [(ngModel)]="author.middleName">
    </div>
    <div class="field col-12">
      <label for="workplace{{idx}}">Место работы</label>
      <input id="workplace{{idx}}" type="text" class="w-full" pInputText [(ngModel)]="author.workplace">
    </div>
    <div class="field col-12">
      <button
      pButton
      pRipple
      type="button"
      label="Удалить автора"
      class="p-button-danger"
      (click)="removeAuthor(idx)"
    ></button>

    </div>
  </div>

</div>

<p-footer>
  <div class="flex flex-row gap-3 mt-3">
  <button pButton class="p-button-success" icon="pi pi-check" label="Сохранить" (click)="onSubmit()"></button>
    <button pButton class="p-button-secondary" icon="pi pi-ban" label="Закрыть" (click)="onCancel()"></button>
    <button pButton class="p-button-info" icon="pi pi-user-plus" label="Добавить автора" (click)="addAuthor()"></button>
    </div>
</p-footer>
